import { render } from "./trainers-table.vue?vue&type=template&id=ed5a961e"
import script from "./trainers-table.vue?vue&type=script&lang=js"
export * from "./trainers-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__